var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }